import { AvailableInStore } from "./components/availableInStore/availableInStore.component";
import { ProductHitsPerPage } from "./components/productHitsPerPage/productHitsPerPage";
import { ProductSort } from "./components/productSort/sort";
import { Sticky } from "./components/sticky/sticky";
import { Base } from "./filters.base";

export const Filters = Object.assign(Base, {
    Sticky: Sticky,
    AvailableInStore: AvailableInStore,
    ProductSort: ProductSort,
    ProductHitsPerPage: ProductHitsPerPage
});
